module.exports = __webpack_public_path__ + "img/guasha.053690ba.png";